import React, { useState, useEffect } from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import Pdf from "../../../assets/images/pdf2.png";
import download from "../../../assets/images/download.png";
import LocPdf from "../../../assets/images/lock-pdf.svg"

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.REACT_APP_API_CHAT_BASE_URL}pdf-viewer/pdf-worker.js`;

function PdfViewer({ url, type, time, scrollToBottom, createdAt, expierMessage, fileName }) {
    const [numPages, setNumPages] = useState("")
    const [isPasswordProtected, setIsPasswordProtected] = useState(true);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setTimeout(() => {
            scrollToBottom();
        }, 2000)
        setNumPages(numPages);
    }
    const [pdfExpired, setPdfExpired] = useState(false)

    const { minutes = 0, seconds = 60 } = { minutes: 5, seconds: 0 };
    const [[mins, secs], setTime] = React.useState([minutes, seconds]);

    function millisToMinutesAndSeconds(millis) {
        var minutes = Math.floor(millis / 60000);
        var seconds = Math.floor((millis % 60000) / 1000);
        setTime([minutes, seconds]);
    }

    useEffect(() => {
        if (Math.abs(new Date(createdAt) - new Date()) < 2000) {
            millisToMinutesAndSeconds(time)
        } else {
            millisToMinutesAndSeconds(String(time - (Math.abs(new Date(createdAt) - new Date()))))
            console.log(Math.abs(new Date(createdAt) - new Date()), "current milisecond")
        }

        if (Math.abs(new Date(createdAt) - new Date()) > time) {
            setPdfExpired(true)
        }
    }, []);

    const tick = () => {
        if (secs > 0) {
            setTime([mins, secs - 1]);
        }
        if (secs === 0) {
            if (mins === 0) {
                setPdfExpired(true)
            } else {
                setTime([mins - 1, 59]);
            }
        }
    };

    React.useEffect(() => {
        const timerId = setInterval(() => tick(), 1000);
        return () => clearInterval(timerId);
    });

    useEffect(() => {
        const checkPDF = async () => {
            try {
                const loadingTask = pdfjs.getDocument({ url, withCredentials: false });
                await loadingTask.promise;
                setIsPasswordProtected(false);
            } catch (e) {
                // console.warn("PDF cannot be previewed:", e);
                setIsPasswordProtected(true);
            }
        };
        checkPDF();
    }, [url]);

    return (
        <div className={`document-wrapper pdf-doc-wraper ${isPasswordProtected ? "lock-wrapper": ""} ${pdfExpired ? "expired-pdf-link" : ""}`}>
            {isPasswordProtected ?
                <img src={LocPdf} alt="loc pdf" style={{minWidth: "60px", padding:"10px"}} />
            :
                <Document file={url}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page pageNumber={1} size="A1" />
                </Document>
            }
            <div className="pdf-bottom-info-wrapper">
                <div className="pdf-info-wrap">
                    <img src={Pdf} alt="csv placeholder" />
                    <div className="pdf-detail-wrapper">
                        <div className="pdf-name"><span style={{ wordBreak: "break-all" }}>{url.substring(url.lastIndexOf('/') + 1)}</span></div>
                        <div className="pdf-other-detail">
                            {/* <span>{numPages} page</span> */}
                            {/* <span className="type-devider"></span>  */}
                            <span className="file-type">{url.split('.').pop()}</span>
                        </div>
                    </div>
                </div>
                {
                    pdfExpired
                        ?
                        <></>
                        :
                        <>
                            <a className='download-links-wrap' href={url} target='_blank' download={expierMessage}></a>
                            <img src={download} alt="download pdf" className="download-img" />
                        </>
                }
            </div>
            {
                !pdfExpired && type === "expired" ?
                    <div className="download-expiry-wrapper">
                        <span className="download-text">{expierMessage}</span>
                        <span className="download-timer">{`${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`}</span>
                    </div>
                    :
                    pdfExpired && type === "expired" ?
                        <div className="download-expiry-wrapper text-danger">
                            <span>&nbsp;</span>
                            <span className="download-text">DOWNLOAD TIMEOUT</span>
                        </div>
                        :
                        <></>
            }
        </div>
    )
}
export default PdfViewer
